import React, { useState } from "react";
import "../../style/pages/categoriespage/midtier.css";
import { useNavigate } from "react-router-dom";
import Header from "../../component/Header.jsx";

import Filter from "../../component/Filter.jsx";
import ItemGrid from "../../component/ItemGrid.jsx";

import m1 from "../../media3/categories/m1.png";
import m2 from "../../media3/categories/m2.png";
import m3 from "../../media3/categories/m3.png";
import m4 from "../../media3/categories/m4.png";
import m5 from "../../media3/categories/m5.png";
import m6 from "../../media3/categories/m6.png";
import m7 from "../../media3/categories/m7.png";
import m8 from "../../media3/categories/m8.png";
import m9 from "../../media3/categories/m9.png";
import m10 from "../../media3/categories/m10.png";
import m11 from "../../media3/categories/m11.png";
import m12 from "../../media3/categories/m12.png";
import m13 from "../../media3/categories/m13.png";
import m14 from "../../media3/categories/m14.png";
import m15 from "../../media3/categories/m15.png";
import m16 from "../../media3/categories/m16.png";
import m17 from "../../media3/categories/m17.png";
import m18 from "../../media3/categories/m18.png";
import m19 from "../../media3/categories/m19.png";
import m20 from "../../media3/categories/m20.png";
import m21 from "../../media3/categories/m21.png";
import m22 from "../../media3/categories/m22.png";
import m23 from "../../media3/categories/m23.png";
import m24 from "../../media3/categories/m24.png";
import m from "../../media3/categories/m.png";

// Dummy data
export const midTierData = [
  { id: 1, name: "MP9 | Slalom", img: m1, price: 61, maxPrice: 122, color: "green", rating: 4, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "MP9 with a green and white ski-themed Slalom paint job, perfect for dodging bullets with alpine agility in close quarters." },
  { id: 2, name: "UMP-45 | Blaze", img: m2, price: 80, maxPrice: 150, color: "white", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "UMP-45 engulfed in white-hot Blaze flames, delivering searing mid-range firepower with elite intensity." },
  { id: 3, name: "MP7 | Fade", img: m3, price: 95, maxPrice: 160, color: "blue", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "MP7 with a smooth blue-to-purple Fade gradient, blending sleek aesthetics with rapid PDW performance." },
  { id: 4, name: "MAC-10 | Orion", img: m4, price: 120, maxPrice: 180, color: "green", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "MAC-10 featuring the cosmic green Orion constellation pattern, spraying stars in chaotic close combat." },
  { id: 5, name: "P90 | See Ya Later", img: m5, price: 70, maxPrice: 125, color: "black", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "P90 with a menacing black 'See Ya Later' mechanical alligator, chomping through rushes with high-capacity humor." },
  { id: 6, name: "PP-Bizon | Hyper Beast", img: m6, price: 90, maxPrice: 140, color: "black", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "PP-Bizon roaring with black Hyper Beast monstrous artwork, unloading massive magazines in feral style." },
  { id: 7, name: "UMP-45 | Fuel Injector", img: m7, price: 110, maxPrice: 160, color: "green", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "UMP-45 with industrial green Fuel Injector mechanics, boosting balanced SMG performance with raw power." },
  { id: 8, name: "MP9 | Melondrama", img: m8, price: 60, maxPrice: 120, color: "yellow", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "MP9 in playful yellow Melondrama watermelon slices, adding fruity fun to close-range sprays." },
  { id: 9, name: "MAC-10 | Llama Cannon", img: m9, price: 75, maxPrice: 130, color: "red", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "MAC-10 with explosive red Llama Cannon artwork, spitting fire with quirky, powerful chaos." },
  { id: 10, name: "P90 | Kill Confirmed", img: m10, price: 145, maxPrice: 200, color: "green", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "P90 marked by green Kill Confirmed bullet holes and blood splatter—proof of high-speed eliminations." },
  { id: 11, name: "MP7 | Bullet Queen", img: m11, price: 88, maxPrice: 150, color: "orange", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "MP7 crowned with orange Bullet Queen royalty and golden accents, reigning over compact firepower." },
  { id: 12, name: "UMP-45 | Handgun", img: m12, price: 55, maxPrice: 110, color: "blue", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "UMP-45 with blue Handgun-inspired compact design, merging pistol reliability into SMG versatility." },
  { id: 13, name: "MP9 | Avalanche", img: m13, price: 68, maxPrice: 125, color: "yellow", rating: 4, rarity: "Restricted", orderedBy: "Newest", currency: "USD", description: "MP9 in yellow Avalanche snowy rush, charging through winter maps with frosty aggression." },
  { id: 14, name: "P90 | Xiangliu", img: m14, price: 92, maxPrice: 160, color: "red", rating: 4, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "P90 coiled in red Xiangliu mythical serpent scales, unleashing venomous high-capacity sprays." },
  { id: 15, name: "MAC-10 | Muertos", img: m15, price: 63, maxPrice: 120, color: "purple", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "MAC-10 celebrating purple Muertos with Day of the Dead skulls, spraying cultural chaos." },
  { id: 16, name: "PP-Bizon | Angry Mob", img: m16, price: 85, maxPrice: 140, color: "blue", rating: 5, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "PP-Bizon fueled by blue Angry Mob protest graffiti, dumping ammo in rebellious fury." },
  { id: 17, name: "UMP-45 | Cobra Strike", img: m17, price: 78, maxPrice: 130, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "UMP-45 with yellow Cobra Strike serpent coils, striking mid-range with deadly precision." },
  { id: 18, name: "MP7 | Crazy 8", img: m18, price: 59, maxPrice: 110, color: "blue", rating: 2, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "MP7 in blue Crazy 8 dice and gambling chaos, spraying unpredictably like a wild bet." },
  { id: 19, name: "P90 | Ticket to Hell", img: m19, price: 99, maxPrice: 160, color: "purple", rating: 5, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "P90 with purple Ticket to Hell demonic flames, rushing into battle with infernal speed." },
  { id: 20, name: "MAC-10 | Water Elemental", img: m20, price: 115, maxPrice: 175, color: "yellow", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "MAC-10 flowing with yellow Water Elemental liquid energy, drowning enemies in mystical spray." },
  { id: 21, name: "PP-Bizon | Asiimov", img: m21, price: 102, maxPrice: 155, color: "red", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "PP-Bizon in red Asiimov futuristic geometric lines, unloading high-tech capacity with style." },
  { id: 22, name: "MP9 | Pole Position", img: m22, price: 66, maxPrice: 125, color: "red", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "MP9 in red Pole Position racing stripes, accelerating close-quarters dominance with speedway flair." },
  { id: 23, name: "UMP-45 | Isaac", img: m23, price: 74, maxPrice: 130, color: "yellow", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "UMP-45 enhanced with yellow Isaac holographic circuits, balancing tech and tactical SMG mastery." },
  { id: 24, name: "P90 | Boost Protocol", img: m24, price: 97, maxPrice: 160, color: "blue", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "P90 upgraded with blue Boost Protocol cybernetic glow, overclocking rush strategies with elite efficiency." }
];

const colors = ["red", "green", "blue", "yellow", "purple", "black", "white", "orange"];
const ratings = [5, 4, 3, 2, 1];

function MidTier({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const [priceRange, setPriceRange] = useState([50, 200]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [openFilter, setOpenFilter] = useState("Price");
    const [selectedRarity, setSelectedRarity] = useState(null);
  const [selectedOrderBy, setSelectedOrderBy] = useState(null);

  const navigate = useNavigate();

  // Filtering
  // const filteredMidTier = midTierData.filter((item) => {
  //   const inPrice = item.price >= priceRange[0] && item.price <= priceRange[1];
  //   const inColor = selectedColors.length === 0 || selectedColors.includes(item.color);
  //   const inRating = !selectedRating || item.rating === selectedRating;
  //   return inPrice && inColor && inRating;
  // });

    let filteredMidTier = midTierData.filter((pistol) => {
    const inPrice = pistol.price >= priceRange[0] && pistol.price <= priceRange[1];
    const inColor = selectedColors.length === 0 || selectedColors.includes(pistol.color);
    const inRating = !selectedRating || pistol.rating === selectedRating;
    const inRarity = !selectedRarity || selectedRarity === "Any" || pistol.rarity === selectedRarity;
    return inPrice && inColor && inRating && inRarity;
  });
  
  // Add sorting
  if (selectedOrderBy) {
    filteredMidTier = [...filteredMidTier].sort((a, b) => {
      switch (selectedOrderBy) {
        case "Price":
          return a.price - b.price;
        case "Rating":
          return b.rating - a.rating;
        case "Popularity":
          return a.id - b.id;
        case "Newest":
          return b.id - a.id;
        default:
          return 0;
      }
    });
  }
  
  const handleRarityChange = (rarity) => {
    setSelectedRarity(rarity === selectedRarity ? null : rarity);
  };
  
  const handleOrderByChange = (orderBy) => {
    setSelectedOrderBy(orderBy === selectedOrderBy ? null : orderBy);
  };

  // Handlers
  const handlePriceChange = (e, idx) => {
    const newRange = [...priceRange];
    newRange[idx] = Number(e.target.value);
    setPriceRange(newRange);
  };

  const handleColorChange = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };

  const handleRatingChange = (rating) => {
    setSelectedRating(rating === selectedRating ? null : rating);
  };
    const handleNavigate = (itemName) => {
    navigate(`/items/${encodeURIComponent(itemName)}`);
  };

  const toggleSection = (section) => {
    setOpenFilter(openFilter === section ? "" : section);
  };

  return (
    <div className="categories-page">
      <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <div className="categories-content">
        <Filter
                openFilter={openFilter}
                toggleSection={toggleSection}
                priceRange={priceRange}
                handlePriceChange={handlePriceChange}
                selectedColors={selectedColors}
                handleColorChange={handleColorChange}
                selectedRating={selectedRating}
                handleRatingChange={handleRatingChange}
                colors={colors}
                ratings={ratings}
                           selectedRarity={selectedRarity}
  handleRarityChange={handleRarityChange}
  selectedOrderBy={selectedOrderBy}
  handleOrderByChange={handleOrderByChange}
              />
              <ItemGrid
                items={filteredMidTier}
                categoryImage={m}
                categoryAlt="CZ75-Auto"
                categoryTitle="MAC-10 | Orion"
                categoryDescription="Discover the perfect balance between affordability and exclusivity with our mid-tier CS2 skins.
Featuring stylish designs and fan-favorite patterns, these skins bring character to every weapon.
Whether it’s pistols, rifles, knives, or gloves — each item delivers standout looks without breaking the bank.
Elevate your inventory and play with confidence, style, and value."
                onItemClick={handleNavigate}
                  isLoggedIn={isLoggedIn}                   
          setLoginModalOpen={setLoginModalOpen}
              />
      </div>
    </div>
  );
}

export default MidTier;